/**
 * Hearing prep checklist — per-barrister, editable template.
 * The items a barrister ticks on every hearing come from THIS list, so each
 * barrister prepares their own way. Null on the server → system defaults.
 */
import { api } from './api';

export interface PrepItem {
  key: string;
  label: string;
}

export interface PrepChecklist {
  professional: PrepItem[];
  operational: PrepItem[];
  isCustom: boolean;
  defaults: { professional: PrepItem[]; operational: PrepItem[] };
}

export async function fetchPrepChecklist(): Promise<PrepChecklist> {
  const res = await api.get('/me/prep-checklist');
  return (res.data as { data: PrepChecklist }).data;
}

export async function savePrepChecklist(body: {
  professional: PrepItem[];
  operational: PrepItem[];
}): Promise<PrepChecklist> {
  const res = await api.put('/me/prep-checklist', body);
  const d = (res.data as { data: Omit<PrepChecklist, 'defaults'> }).data;
  return d as PrepChecklist;
}

export async function resetPrepChecklist(): Promise<PrepChecklist> {
  const res = await api.post('/me/prep-checklist/reset');
  return (res.data as { data: PrepChecklist }).data;
}
